import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { useTranslation } from "react-i18next";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../AddProject.style";
import { Stack } from "@fluentui/react";

const Branch = (props) => {
  const { branch } = props;
  const { t } = useTranslation();
  const style = Style();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t('project.branch')}
          validationMessage={props.errors?.branch?.message}
          id="branch"
          placeholder={t('project.enter_branch_name')}
          name="branch"
          inputDefaultValue={branch}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("branch", {
            required:`${t('validation_message.branch_is_required')}`,
          })}
        />
      </Stack>
    </>
  );
};

export default Branch;
